<template>
  <v-container>
    <ResourceDialog
      @save="save"
      ref="termsAgreementDialog"
      :cancellable="false"
      :max-width="800"
      :processing="processing"
      :save-button-text="termsAgreement.accept_label"
      :title="termsAgreement.title"
      center-title
    >
      <template #form>
        <v-row>
          <v-col>
            <MarkdownContent
              :content="termsAgreement.content"
              class="focus-very-visible fs-16"
              tabindex="0"
            />
          </v-col>
        </v-row>
      </template>
    </ResourceDialog>
  </v-container>
</template>

<script setup>
import Api from '@/shared/services/bright_finder';
import { getRecaptchaEnterpriseToken } from '@/shared/services/google_recaptcha_enterprise';
import MarkdownContent from '@/shared/components/MarkdownContent.vue';
import ResourceDialog from '@/shared/components/form/ResourceDialog.vue';
import useEventBus from '@/shared/composables/useEventBus';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

const eventBus = useEventBus();
const router = useRouter();
const store = useStore();

const processing = ref(false);
const termsAgreement = ref(store.state.config.terms_agreement);
const termsAgreementDialog = ref(null);

onMounted(() => {
  termsAgreementDialog.value.open({});
});

async function save() {
  const token = await getRecaptchaEnterpriseToken();
  processing.value = true;

  const resp = await Api.member.profile
    .update({
      terms_agreement_id: termsAgreement.value.id,
      token,
    })
    .catch((error) => eventBus.error(error));

  if (!resp?.data) return;

  store.commit('setProfile', resp.data);
  router.replace({ name: 'Dashboard' });
}
</script>
